export class CapiRequest{
    can_purge: boolean;
    bot_organization: string;
    bot_authorization: string;
}